import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Table from "@empd/reactable";
import "@empd/reactable/lib/styles.css";

import {
    Container,
    Row,
    Col,
    Button,
    Breadcrumb,
    Spinner,
    Card,
    CardImg,
    Form,
} from "react-bootstrap";

import CustomNavbar from "../../components/CustomNavbar";
import CustomFooter from "../../components/CustomFooter";
import ShowInfo from "../../components/ShowInfo";
import MainContentSpaced from "../../components/MainContentSpaced";

import api from "../../service/api";
import { TOKEN_BRANCHID } from "../../service/tokens";

const BranchLogo = (props) => {
    const [emptyDataElement, setEmptyDataElement] = useState(
        <Spinner animation="grow" />
    );

    const [branch, setBranch] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertText, setAlertText] = useState("");
    const [alertVariant, setAlertVariant] = useState("");

    const [file, setFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);

    useEffect(
        function () {
            async function loadBranch() {
                const branchId = Number(
                    window.localStorage.getItem(TOKEN_BRANCHID)
                );

                const responseGetBranch = await api.get(`/branch/${branchId}`);

                if (responseGetBranch.data.error) {
                    alert(
                        "Erro ao buscar os dados da Filial. Contate o suporte!"
                    );
                    setTimeout(function () {
                        props.history.push("/dashboard");
                    }, 2000);
                } else {
                    setBranch(responseGetBranch.data.data.branch);
                }
            }

            loadBranch();
        },
        [props.history]
    );

    function handleSubmit(e) {
        e.preventDefault();

        async function postBranchLogo() {
            const formData = new FormData();
            formData.append("logo_branch", file);

            const responsePostBranchLogo = await api.post(
                `/branch/${branch.id}/logo-branch`,
                formData
            );

            if (
                responsePostBranchLogo.data.error ||
                responsePostBranchLogo.status === 500
            ) {
                setShowAlert(true);
                setAlertTitle("Problemas ao atualizar a foto.");
                setAlertText(
                    `Tivemos problemas ao atualizar sua foto. Por favor contate o suporte!`
                );
                setAlertVariant("danger");
            } else {
                setShowAlert(true);
                setAlertTitle("Foto atualizada com sucesso!");
                setAlertText(
                    `Você será redirecionado automaticamente para a home.`
                );
                setAlertVariant("success");

                setTimeout(() => {
                    props.history.push("/dashboard");
                }, 3000);
            }
        }

        postBranchLogo();
    }

    return (
        <>
            <CustomNavbar />
            <MainContentSpaced>
                <Container>
                    <Row>
                        <Col>
                            <ShowInfo
                                title={alertTitle}
                                text={alertText}
                                show={showAlert}
                                variant={alertVariant}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Breadcrumb>
                                <Breadcrumb.Item
                                    style={{
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        props.history.push("/dashboard")
                                    }
                                >
                                    Dashboard
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>
                                    Atualizar Logo
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formFile">
                                    <Form.Label>Imagem</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={(e) => {
                                            const fileUpload =
                                                e.target.files[0];
                                            setFile(fileUpload);
                                            setFilePreview(
                                                URL.createObjectURL(fileUpload)
                                            );
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        A foto precisa ter o tamanho mínimo de
                                        680px Largura e 715px Altura.
                                    </Form.Text>
                                </Form.Group>

                                <Button variant="success" type="submit">
                                    Enviar!
                                </Button>

                                {filePreview ? (
                                    <Card
                                        style={{
                                            marginBottom: 40,
                                        }}
                                    >
                                        <CardImg
                                            top
                                            src={filePreview}
                                            alt="Card image cap"
                                        />
                                        <Card.Body>
                                            <Card.Title>
                                                Preview da Foto.
                                            </Card.Title>
                                        </Card.Body>
                                    </Card>
                                ) : null}
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </MainContentSpaced>
            <CustomFooter />
        </>
    );
};

export default withRouter(BranchLogo);
